<template>
  <div id="next-upgrade">
    <div>
      <span class="strong">Name:</span>
      {{ nextUpgrade.name }}
    </div>
    <div>
      <span class="strong">Price:</span>
      {{ thousandSeparator(nextUpgrade.price) }}
    </div>
    <div>
      <span class="strong">Price per CPS:</span>
      {{ thousandSeparator((nextUpgrade.valuePerCps || 0).toFixed(2)) }}
    </div>
    <Button v-on:button-clicked="updateNextUpgrade()" text="Next upgrade" />
  </div>
</template>

<script>
import Button from "./Button";

export default {
  name: "NextUpgrade",
  components: {
    Button
  },
  data() {
    return {
      nextUpgrade: {
        index: 0,
        name: null,
        price: null,
        valuePerCps: null
      }
    };
  },
  methods: {
    thousandSeparator: function(number) {
      if (!number) {
        return;
      }

      return this.$parent.thousandSeparator(number);
    },

    setNextUpgrade: function(upgrades) {
      if (upgrades.length === 0) {
        return;
      }

      const newNextUpgrade = upgrades.reduce(
        (acc, upgrade, index) => {
          const upgradeValuePerCps = this.getValuePerCps(upgrade);

          if (acc.valuePerCps > 0 && upgradeValuePerCps >= acc.valuePerCps) {
            return acc;
          }

          return { index, upgrade, valuePerCps: upgradeValuePerCps };
        },
        { index: 0, upgrade: null, valuePerCps: 0 }
      );

      const price = this.$parent.getNextPrice(newNextUpgrade.upgrade);

      this.nextUpgrade = {
        index: newNextUpgrade.index,
        name: newNextUpgrade.upgrade.name,
        price: price,
        valuePerCps: newNextUpgrade.valuePerCps
      };

      this.$emit("next-upgrade-index", newNextUpgrade.index);
    },

    getValuePerCps: function(upgrade) {
      const nextPrice = this.$parent.getNextPrice(upgrade);

      return nextPrice / upgrade.cps;
    },

    updateNextUpgrade: function() {
      this.upgrades[this.nextUpgrade.index].qty += 1;
    }
  },
  props: {
    upgrades: Array
  },
  mounted: function() {
    this.setNextUpgrade(this.upgrades);
  },
  watch: {
    upgrades: {
      handler(newVal) {
        this.setNextUpgrade(newVal);
      },
      deep: true
    }
  }
};
</script>

<style scoped>
#next-upgrade {
  margin-top: 15px;
}

.strong {
  font-weight: bold;
}
</style>
